import script from "./ProductSafetySection.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSafetySection.vue?vue&type=script&setup=true&lang=js"

import "./ProductSafetySection.vue?vue&type=style&index=0&id=1e895644&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e895644"]])

export default __exports__